import { useState } from 'react'
import { Link, NavLink } from 'react-router'
import { RiMenuLine } from 'react-icons/ri'
import { cn } from '@/lib/cn'
import { useNavScroll } from '@/hooks'
import { ROUTES } from '@/constants/routes'
import { MobileMenu } from './MobileMenu'
import logoSrc from '@/assets/logo/logo.png'

const navLinks = [
  { to: ROUTES.HOME, label: 'Home', end: true },
  { to: ROUTES.ABOUT, label: 'About Simone', end: false },
  { to: ROUTES.SERVICES, label: 'Services', end: false },
  { to: ROUTES.HER_JOURNEY_HUB, label: 'Journey Hub', end: false },
  { to: ROUTES.STORIES, label: 'Stories', end: false },
  { to: ROUTES.FAQ, label: 'FAQ', end: false },
  { to: ROUTES.ENQUIRY, label: 'Enquiry', end: false },
]

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { scrolled, visible } = useNavScroll()

  return (
    <>
      <header
        className={cn(
          'fixed top-0 left-0 right-0 z-50 bg-white transition-all duration-300',
          scrolled && 'shadow-[0_2px_16px_rgba(155,28,28,0.08)]',
          visible ? 'translate-y-0' : '-translate-y-full',
        )}
      >
        <div className="max-w-[1200px] mx-auto px-6 h-[76px] grid grid-cols-2 md:grid-cols-3 items-center">
          {/* Left: Logo */}
          <div className="justify-self-start">
            <Link to={ROUTES.HOME}>
              <img src={logoSrc} alt="H.E.R Birth Keeper" className="h-12 w-auto block" />
            </Link>
          </div>

          {/* Centre: Pill nav (desktop only) */}
          <nav className="justify-self-center hidden md:flex">
            <div className="flex items-center gap-0.5 rounded-full px-2 py-1.5 bg-base-100">
              {navLinks.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  className={({ isActive }) =>
                    cn(
                      'px-4 py-[7px] rounded-full text-[13px] font-medium whitespace-nowrap transition-all duration-200',
                      isActive
                        ? 'bg-white text-crimson-600 shadow-sm'
                        : 'text-base-700 hover:text-crimson-600 hover:bg-white/80',
                    )
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </nav>

          {/* Right: CTA (desktop) + hamburger (mobile) */}
          <div className="justify-self-end flex items-center">
            <Link to={ROUTES.ENQUIRY} className="nav-cta hidden md:inline-block">
              Book Your Free Call
            </Link>
            <button
              className="md:hidden flex items-center justify-center w-9 h-9 rounded-full bg-white/80 backdrop-blur-sm text-base-800 hover:bg-white transition-all"
              onClick={() => setMenuOpen(true)}
              aria-label="Open navigation menu"
            >
              <RiMenuLine size={20} />
            </button>
          </div>
        </div>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  )
}
